import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

export { cva, type VariantProps } from 'class-variance-authority';

// Extend twMerge to recognize our custom font size classes
// Without this, text-tiny-plus conflicts with text-white (both have text- prefix)
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': ['text-tiny', 'text-tiny-plus', 'text-xs-plus', 'text-sm-plus'],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
